import * as React from "react"
import { FC, useState } from "react"
import Spinner from "../../Spinner"
import styled from "styled-components"
import { grey } from "../../../constants/colors"
import { PrimaryButton } from "components"
import { subscribe } from "../../../api/leadCaptureApi"
import { screenSizes } from "model"

const Container = styled.div`
  width: 100%;
  background-color: ${grey};
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`
const Checkboxes = styled.div`
  margin: auto;
  display: flex;
  margin-bottom: 20px;
`
const Checkbox = styled.div`
  margin: 10px;
  display: flex;
  cursor: pointer;
  user-select: none;

  input {
    margin-right: 10px;
    display: block;
    cursor: pointer;
  }

  label {
    width: 200px;
    cursor: pointer;
  }
`

const Message = styled.p`
  width: 100%;
  max-width: 700px;
  text-align: center;
  margin: auto auto 40px;
`

const Form = styled.div`
  form {
    width: 100%;
    max-width: 800px;
    margin: auto;
    display: flex;
    @media (max-width: ${screenSizes.tablet}px) {
      flex-direction: column;
    }
  }
`

const Input = styled.input`
  flex: 2;
  margin-right: 10px;
  @media (max-width: ${screenSizes.tablet}px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`

const StyledPrimaryButton = styled(PrimaryButton)`
  flex: 1;
`

interface Props {}

const Subscribe: FC<Props> = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSent, setIsSent] = useState<boolean>(false)
  const [email, setEmail] = useState<string>("")
  const [forIndividuals, setForIndividuals] = useState<boolean>(true)
  const [forCompanies, setForCompanies] = useState<boolean>(false)

  const handleChange = event => setEmail(event.target.value)

  const handleSubmit = event => {
    event.preventDefault()

    setIsLoading(true)

    subscribe(email, forIndividuals, forCompanies)
      .then(() => {
        setIsSent(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Container id="newsletter">
      <Spinner isLoading={isLoading} label={"Subscribing"} />
      <Message>
        Join our community where every business is a force for good. We have two newsletters – one
        dedicated to individuals and another for B2B clients. Either way, we promise only good news,
        quality products and exclusive offers.
      </Message>

      {isSent ? (
        <Message>Thank you, you are now subscribed</Message>
      ) : (
        <FormContainer>
          <Checkboxes>
            <Checkbox>
              <input
                type="checkbox"
                id="individuals"
                name="individuals"
                value="individuals"
                checked={forIndividuals}
                onClick={() => setForIndividuals(!forIndividuals)}
              />
              <label htmlFor="individuals">For Individuals</label>
            </Checkbox>
            <Checkbox>
              <input
                type="checkbox"
                id="companies"
                name="companies"
                value="companies"
                checked={forCompanies}
                onClick={() => setForCompanies(!forCompanies)}
              />
              <label htmlFor="companies">For Companies</label>
            </Checkbox>
          </Checkboxes>
          <Form>
            <form onSubmit={handleSubmit} id={"SubscribeForm"}>
              <Input
                type="email"
                placeholder="Your Email Address"
                onChange={handleChange}
                value={email}
              />
              <StyledPrimaryButton disabled={!email}>Join</StyledPrimaryButton>
            </form>
          </Form>
        </FormContainer>
      )}
    </Container>
  )
}

export default Subscribe
